/** @type {import('next').NextConfig} */
const nextConfig = {
  reactStrictMode: true,
  swcMinify: true,
  experimental: {
    // optimizeCss: true,
    fontLoaders: [
      { loader: "@next/font/google", options: { subsets: ["latin"] } },
    ],
  },
  images: {
    domains: [
      "quebuster.s3.ap-south-1.amazonaws.com",
      "qbstore.s3.ap-south-1.amazonaws.com",
      "blog.queuebuster.co",
      "new.queuebuster.co",
      "queuebuster.co",
      "www.queuebuster.co",
    ],
  },
  productionBrowserSourceMaps: true,
  output: "export",
};

module.exports = nextConfig;
